import { render, staticRenderFns } from "./helpCenter.vue?vue&type=template&id=356cf659&scoped=true&"
import script from "./helpCenter.vue?vue&type=script&lang=js&"
export * from "./helpCenter.vue?vue&type=script&lang=js&"
import style0 from "./helpCenter.vue?vue&type=style&index=0&id=356cf659&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356cf659",
  null
  
)

export default component.exports